import { db } from "../firebaseClient"
import { doc, setDoc, updateDoc, collection, getDocs, query, where, serverTimestamp, increment } from "firebase/firestore"
import { dateKeyFor } from "./dateRangeHelpers"

// One doc per learning session. durationSeconds accumulates heartbeat-by-heartbeat
// rather than being computed from endedAt - startedAt, so a session that never
// cleanly ends (tab closed, no beforeunload) still has an accurate duration up
// to its last heartbeat instead of reporting 0 or blowing up on missing endedAt.
const HEARTBEAT_INTERVAL_SECONDS = 30
export const HEARTBEAT_MS = HEARTBEAT_INTERVAL_SECONDS * 1000

export const startLearningSession = async ({ orgId, userId, courseId, lessonId }) => {
  if (!orgId || !userId) return { sessionId: null, error: null }
  try {
    const ref = doc(collection(db, "learningSessions"))
    await setDoc(ref, {
      sessionId: ref.id,
      orgId,
      userId,
      courseId: courseId || null,
      lessonId: lessonId || null,
      dateKey: dateKeyFor(new Date()),
      startedAt: serverTimestamp(),
      lastHeartbeatAt: serverTimestamp(),
      endedAt: null,
      durationSeconds: 0,
    })
    return { sessionId: ref.id, error: null }
  } catch (error) {
    return { sessionId: null, error }
  }
}

export const heartbeatLearningSession = async (sessionId) => {
  if (!sessionId) return { error: null }
  try {
    await updateDoc(doc(db, "learningSessions", sessionId), {
      lastHeartbeatAt: serverTimestamp(),
      durationSeconds: increment(HEARTBEAT_INTERVAL_SECONDS),
    })
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export const endLearningSession = async (sessionId) => {
  if (!sessionId) return { error: null }
  try {
    await updateDoc(doc(db, "learningSessions", sessionId), { endedAt: serverTimestamp() })
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export const listOrgLearningSessions = async (orgId) => {
  try {
    const ref = collection(db, "learningSessions")
    const q = query(ref, where("orgId", "==", orgId))
    const snap = await getDocs(q)
    return { sessions: snap.docs?.map((d) => d.data()), error: null }
  } catch (error) {
    return { sessions: [], error }
  }
}